import GSAP from 'gsap'
import Experience from '../Experience'
import Environment from './Environment'
import Floor from './Floor'
import Steeple from './Steeple'

export default class World {
  constructor() {
    //setup
    this.experience = new Experience()
    this.camera = this.experience.camera
    this.scene = this.experience.scene
    this.resources = this.experience.resources
    this.loader = document.querySelector('.loader')

    //resources
    this.resources.on('ready', () => {
      this.floor = new Floor()
      this.steeple = new Steeple()
      this.environment = new Environment()

      setTimeout(() => {
        GSAP.to(this.loader, { autoAlpha: 0, duration: 1, ease: 'linear' })
      }, 2000)
    })
  }
  update() {
    if (this.steeple) {
      this.steeple.update()
    }
  }
}
